import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_POPOVER } from '../../../../../../constants'
import { getFeatureFromCache } from '../../../../../../util/feature-cache'
import {
  LineItemFulfilmentNewCustomerDetailsViewProps,
  LineItemFulfilmentNewCustomerDetailsView as LineItemFulfilmentNewCustomerDetailsViewUnified,
} from './LineItemFulfilmentNewCustomerDetailsView'
import { LineItemFulfilmentNewCustomerDetailsViewLegacy } from './LineItemFulfilmentNewCustomerDetailsViewLegacy'

export const LineItemFulfilmentNewCustomerDetailsView: React.FC<LineItemFulfilmentNewCustomerDetailsViewProps> = props => {
  const isUnifiedFulfilmentUiEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_POPOVER
  )

  return isUnifiedFulfilmentUiEnabled ? (
    <LineItemFulfilmentNewCustomerDetailsViewUnified {...props} />
  ) : (
    <LineItemFulfilmentNewCustomerDetailsViewLegacy {...props} />
  )
}

export type { LineItemFulfilmentNewCustomerDetailsViewProps }
